import type {FC} from 'react';

import {Text} from '../../../../uikit/Text';
import * as S from './styles';

type Props = {
  clientsAmount: number;
  groupSize: number;
  status: string;
  title: string;
};

export const CourseToJoinPreviewJSX: FC<Props> = ({
  clientsAmount,
  groupSize,
  status,
  title,
}) => {
  return (
    <S.Container>
      <S.Row>
        <S.CalendarIcon />
        <Text weight="semibold">{title}</Text>
      </S.Row>
      <S.Row>
        <S.GroupIcon />
        <Text weight="semibold">{`${clientsAmount}/${groupSize}`}</Text>
        <Text color="text3" weight="semibold">
          {status}
        </Text>
      </S.Row>
    </S.Container>
  );
};
